
import { JobDetailedStopNotes } from '@/models/jobDetailed';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Note extends Vue {
  @Prop({ type: Object, required: true }) private readonly note!: JobDetailedStopNotes;
}
